export enum IntegrationGuideName {
    BigCommerce = 'BigCommerce',
    Ecwid = 'Ecwid',
    Prestashop = 'Prestashop',
    Shopify = 'Shopify',
    Wix = 'Wix',
    Woocommerce = 'Woocommerce',
}
